import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import SignIn from './pages/SignIn';
import Driver from './pages/Driver';
import Admin from './pages/admin/Admin';
import User from './pages/user/User';
import ChangePassword from './pages/ChangePassword';
import ToastContainer from './Components/ToastContainer';
import DeviceAuthentication from './pages/DeviceAuthentication';
import IdleTimeoutProvider from './Components/IdleTimeoutProvider';

function App() {
  return (
    <Router>
      <IdleTimeoutProvider>
        <div className="App">
          <ToastContainer />
          <Routes>
            <Route path="/" element={<SignIn />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/driver" element={<Driver />} />
            <Route path="/admin/*" element={<Admin />} />
            <Route path="/user/*" element={<User />} />
          </Routes>
        </div>
      </IdleTimeoutProvider>
    </Router>
  );
}

export default App;
